<template>
  <div class="d2-container-full">
    <div v-if="$slots.header" class="d2-container-full__header" ref="header">
      <slot name="header" />
    </div>
    <!-- <span style="display: block;height: 1px;margin: 0 18px;background: #e5e6eb
;"></span> -->
    <div v-if="$slots.body" ref="body" class="full-body">
      <slot name="body" />
    </div>
    <div v-else class="d2-container-full__body full-body">
      <slot />
    </div>
    <div v-if="$slots.footer" class="d2-container-full__footer" ref="footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import scroll from './mixins/normal'
export default {
  name: 'd2-container-full',
  mixins: [
    // scroll
  ],
  mounted() {
    // 增加滚动事件监听
    // this.addScrollListener()
  },
  beforeDestroy() {
    // 移除滚动事件监听
    // this.removeScrollListener()
  }
}
</script>
<style lang="scss" scoped>
.full-body {
  flex: 1;
  overflow: hidden;
}

.d2-container-full {
  right: 0 !important;
}
</style>